<template>
  <Modal v-if="display" @hideModal="toggleModal" wide customwidth="modalWidth-1250"  modalbgCustom="modal-bg-blur">
    <div class="flex flex-wrap font-bold">
      <div class="w-1/2" style="font-size: 1.25rem;color: #00953A;">
        Welcome to the Family!
      </div>
    </div>
    <p style="font-size: 0.85rem;">
      As your local lawn, tree and pest professionals, we tailor our services to your landscape's unique needs.
    </p>

    <div class="flex flex-wrap mt-8">
      <div class="w-full sm:w-1/5">
        <img :src="`${urlLocation}/services/lawn-care/service-lawn-care-preferred-program-600x600.webp`"
          style="max-height: 150px; border-radius: 15px;" class="mr-5" alt="" />
      </div>

      <div class="w-full sm:w-3/5">
        <div style="font-size: 1.5rem;font-weight: bold;" class="mb-10">
          Use Code <span class="txt-00953A"> Welcome10 </span> for <span class="txt-00953A">$10 off</span> at
          Checkout
        </div>

        <div style="font-size: 0.75rem;" class="mb-5">
          Valid for first-time US customers and new email subscribers only. Offer valid on Lawn Programs only.
          Limit one (1) per household. Cannot be combined with other offers. By entering your email address,
          you agree to our <NuxtLink to="/policies/privacy-policy/" target="_blank">Privacy Policy</NuxtLink> & <NuxtLink to="/policies/terms-use/" target="_blank">Terms of Use</NuxtLink>.
        </div>
      </div>

      <div class="w-full sm:w-1/5">
        <div class="mt-4 flex justify-end ">
          <button @click="hide" class="button add-to-cart">
            See Lawn Programs
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { useStore } from 'vuex';
import type { Store } from 'vuex/types/index.js';
import type State from '~/domains/store/State';
import Modal from '~/components/Modal.vue';

const { $config } = useNuxtApp();
const store: Store<State> = useStore();

const props = defineProps({
  displayCouponModal: {
    type: Boolean,
    default: false,
  },
});

const display = ref(true);
const urlLocation = ref($config.public.sgCmsImage);

const hide = () => {
  store.commit("SET_EMAILCAPTUREFLAG", true);
  display.value = false;
};

const toggleModal = () => {
  store.commit("SET_EMAILCAPTUREFLAG", true);
  display.value = !display.value;
};
</script>

<style scoped>
.txt-00953A {
  color: #00953A;
}

.add-to-cart {
  border-radius: 15px;
  padding: 0.75rem;
  font-size: 1rem;
}
</style>
